var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgZipButtonWht(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 135,
    viewBox: "0 0 300 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M300 20C300 8.9543 291.046 0 280 0H20C8.9543 0 0 8.95431 0 20V115C0 126.046 8.95431 135 20 135H280C291.046 135 300 126.046 300 115V20Z",
    fill: "#FFFFFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M117.043 46.5264L123.925 102.52H191.223L184.34 46.5264H117.043Z",
    fill: "#AA8FFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M136.241 25.159C140.533 29.1942 141.122 35.5407 137.556 39.3346C133.99 43.1285 127.619 42.9328 123.327 38.8977C119.035 34.8626 118.446 28.5161 122.012 24.7222C125.578 20.9284 131.949 21.1239 136.241 25.159Z",
    fill: "#1A0826"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M261.751 66.6885C260.202 54.0955 250.31 46.4822 236.877 46.5264H192.13L199.012 102.52H219.151L217.779 91.3212H239.09C255.842 91.3212 263.521 80.8749 261.751 66.6885ZM236.899 75.6298L215.831 75.6519L214.171 62.2179L235.35 62.24C240.329 62.3064 242.874 65.095 243.295 68.9459C243.56 71.4026 242.431 75.6298 236.899 75.6298Z",
    fill: "#1A0826"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9571 86.8728L48.8824 102.52H116.113L113.9 84.6153H82.5643L82.2766 82.38L111.156 62.218L109.231 46.5265H42L44.1909 64.4532H75.5934L75.8811 66.6886L46.9571 86.8728Z",
    fill: "#1A0826"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZipButtonWht);
export default __webpack_public_path__ + "static/media/zip-button-wht.d947342c17f775ebb03ad42ce6b9fc3a.svg";
export { ForwardRef as ReactComponent };